module.exports = function filterPrivatePageContext(pageContext) {
	return {
		bundles: pageContext.bundles,
		layouts: pageContext.layouts,
		configs: pageContext.configs,
		parent_nid: pageContext.nid,
		private: true,
		type: "node",
	};
};
